import { render, staticRenderFns } from "./baoming.vue?vue&type=template&id=00b54574&"
import script from "./baoming.vue?vue&type=script&lang=js&"
export * from "./baoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports